import { Component, OnInit } from '@angular/core';
import { User, AccessToken } from "../../shared/sdk/models";
import { UserApi } from "../../shared/sdk/services";
import { Router, ActivatedRoute } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { LoopBackConfig } from "../../shared/sdk/index";
import { BASE_URL, API_VERSION } from "../../shared/base.url";


@Component({
  selector: 'app-log-in',
  templateUrl: './log-in.component.html',
  styleUrls: ['./log-in.component.scss']
})
export class LogInComponent implements OnInit {
  hide: boolean;
  signInForm: FormGroup;
  error: boolean;
  loading: boolean;

  constructor(
    private fb: FormBuilder,
    private userApi: UserApi,
    private router: Router
  ) {
    this.hide = true;
  }

  ngOnInit() {
    LoopBackConfig.setBaseURL(BASE_URL);
    LoopBackConfig.setApiVersion(API_VERSION);
    this.signInForm = this.fb.group({
      emailFC: [null, [Validators.required, Validators.email]],
      passFC: [null, Validators.required]
    });
  }
  onSubmit() {
    if (this.signInForm.valid) {
      this.loading = true;
      this.userApi
        .login(
          new User({
            email: this.signInForm.value.emailFC,
            password: this.signInForm.value.passFC
          })
        )
        .subscribe(
          (token: AccessToken) => {
            this.loading = false;
            this.router.navigate(["/dashBoard"]);
          },
          err => {
            this.loading = false;
            this.error = err;
          }
        );
    }
  }

}
